import http from "@/settings/apiSettings"

class DOC_LiniiDataService {
    save(documentId: string, data: any): Promise<any> {
        return http.clientDocumenteOdata.post(`/DOC_Linii/${documentId}`, data);
    }

    update(linieId: string, data: any): Promise<any> {
        return http.clientDocumenteOdata.put(`/DOC_Linii/${linieId}`, data)
    }
}
export default new DOC_LiniiDataService();